export default __webpack_public_path__ + "static/media/teste.9bc6cf82.png";